import React from 'react';
import { motion } from 'framer-motion';
import { Crown, Zap } from 'lucide-react';

const LeaderboardRow = ({ user, index, isCurrentUser }) => {
  const maskAni = (ani) => {
    const str = String(ani);
    if (str.length <= 4) return str;
    return `${str.slice(0, 3)}****${str.slice(-4)}`;
  };

  return (
    <motion.div
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
      whileHover={{ scale: 1.01, x: 5 }}
      className={`relative flex items-center justify-between p-6 md:p-8 rounded-3xl mb-4 overflow-hidden group border ${
        isCurrentUser 
          ? 'bg-purple-900/40 border-purple-500/50 shadow-[0_0_30px_rgba(168,85,247,0.2)]' 
          : 'bg-gray-800/40 border-gray-700/30 hover:bg-gray-800/60'
      }`}
    >
      {/* Animated gradient border for current user */}
      {isCurrentUser && (
        <div className="absolute top-0 left-0 w-2 h-full bg-gradient-to-b from-purple-400 to-blue-500 shadow-[0_0_15px_rgba(168,85,247,0.8)]"></div>
      )}

      <div className="flex items-center gap-6 md:gap-8 z-10">
        <div className="relative flex items-center justify-center w-16 h-16 min-w-[4rem] rounded-2xl font-black text-3xl md:text-4xl z-10 mr-4">
          {index === 0 && (
            <>
              <div className="absolute inset-0 bg-gradient-to-br from-yellow-300 to-yellow-600 rounded-2xl opacity-20"></div>
              <div className="absolute inset-0 border-2 border-yellow-400 rounded-2xl shadow-[0_0_20px_rgba(250,204,21,0.6)]"></div>
              <span className="text-yellow-400 z-10 drop-shadow-md">1</span>
              <Crown className="absolute -top-5 -right-4 w-10 h-10 text-yellow-400 drop-shadow-[0_0_10px_rgba(250,204,21,1)] rotate-12" fill="currentColor" />
            </>
          )}
          {index === 1 && (
            <>
              <div className="absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-500 rounded-2xl opacity-20"></div>
              <div className="absolute inset-0 border-2 border-gray-300 rounded-2xl shadow-[0_0_15px_rgba(209,213,219,0.4)]"></div>
              <span className="text-gray-200 z-10 drop-shadow-md">2</span>
              <Crown className="absolute -top-4 -right-3 w-8 h-8 text-gray-300 drop-shadow-[0_0_5px_rgba(209,213,219,0.5)] rotate-12" fill="currentColor" />
            </>
          )}
          {index === 2 && (
            <>
              <div className="absolute inset-0 bg-gradient-to-br from-orange-400 to-orange-700 rounded-2xl opacity-20"></div>
              <div className="absolute inset-0 border-2 border-orange-400 rounded-2xl shadow-[0_0_15px_rgba(249,115,22,0.4)]"></div>
              <span className="text-orange-400 z-10 drop-shadow-md">3</span>
              <Crown className="absolute -top-4 -right-3 w-8 h-8 text-orange-400 drop-shadow-[0_0_5px_rgba(249,115,22,0.5)] rotate-12" fill="currentColor" />
            </>
          )}
          {index > 2 && (
            <>
              <div className="absolute inset-0 bg-gray-800 rounded-2xl opacity-50"></div>
              <div className="absolute inset-0 border border-gray-600 rounded-2xl"></div>
              <span className="text-gray-400 z-10">{index + 1}</span>
            </>
          )}
        </div>
        <div>
          <p className={`font-bold text-2xl md:text-3xl tracking-wide ${isCurrentUser ? 'text-white' : 'text-gray-200'}`}>
            {maskAni(user.ani)}
            {isCurrentUser && <span className="ml-4 text-sm bg-purple-500/20 text-purple-300 px-3 py-1.5 rounded-full border border-purple-500/30">YOU</span>}
          </p>
        </div>
      </div>

      <div className="z-10 flex items-center gap-3">
        <span className="font-bold text-3xl md:text-4xl text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-purple-400">
          {user.totalPoints}
        </span>
        <span className="text-base text-gray-400 font-semibold uppercase tracking-wider hidden md:block">pts</span>
        <Zap className="w-6 h-6 text-purple-400/50" />
      </div>
    </motion.div>
  );
};

export default LeaderboardRow;
